const AuthSideItem = ({
  image,
  altText,
  title,
  subtitle,
  buttonAction,
}) => {
  return (
    <div className="h-full w-full flex flex-col justify-center items-center rounded-3xl text-white text-center space-y-4 bg-primary">
      <img src={image} alt={altText} className="h-[15rem]" />
      <div className="text-2xl font-bold">{title}</div>
      <div className="">{subtitle}</div>
    
    </div>
  );
};

export default AuthSideItem;
